export default "__VITE_ASSET__C8R0trhZ__"